import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cloudDeploymentsHero from "../assets/Hero/cloud-deployment.avif"; // Replace with your hero image
import azureImage from "../assets/Hero/azure.png"; // Replace with your Azure image
import awsImage from "../assets/Hero/cloud-audit-hero.jpg"; // Replace with your AWS image
import googleCloudImage from "../assets/Hero/cloud-computing.png"; // Replace with your Google Cloud image
import oracleImage from "../assets/Hero/oracle-deployment.jpg"; // Replace with your Oracle image
import serverCoreImage from "../assets/Hero/servercore-deployment.webp"; // Replace with your Server Core image
import "../assets/css/cloudDeploymentsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const cloudDeploymentsData = {
  hero: {
    title: "Cloud Deployments",
    subtitle: "Seamless Cloud Solutions for Azure, AWS, Google Cloud, Oracle, and Server Core",
  },
  introduction: {
    heading: "Why Cloud Deployments Matter",
    paragraphs: [
      "Cloud deployments enable businesses to leverage scalable, secure, and efficient cloud platforms for their operations.",
      "Our cloud deployment solutions are designed to provide seamless integration, robust performance, and expert support for Azure, AWS, Google Cloud, Oracle, and Server Core.",
    ],
  },
  deployments: [
    {
      name: "Azure",
      image: azureImage,
      description: "Microsoft Azure provides a comprehensive suite of cloud services for building, deploying, and managing applications.",
    },
    {
      name: "AWS",
      image: awsImage,
      description: "Amazon Web Services (AWS) offers scalable and reliable cloud computing solutions for businesses of all sizes.",
    },
    {
      name: "Google Cloud",
      image: googleCloudImage,
      description: "Google Cloud delivers cutting-edge cloud infrastructure and data analytics solutions.",
    },
    {
      name: "Oracle",
      image: oracleImage,
      description: "Oracle Cloud provides enterprise-grade cloud solutions for databases, applications, and infrastructure.",
    },
    {
      name: "Server Core",
      image: serverCoreImage,
      description: "Server Core offers lightweight and efficient server deployments for modern applications.",
    },
  ],
  cta: {
    heading: "Ready to Deploy Your Cloud Solutions?",
    text: "Contact us today to learn more about our Cloud Deployment Solutions and how we can help your business thrive.",
  },
};

export const CloudDeploymentsPage = ({ data }) => {
  const cloudDeploymentsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = cloudDeploymentsRef.current.querySelectorAll(".cloud-deployments-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: cloudDeploymentsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="cloud-deployments-page" ref={cloudDeploymentsRef}>
      {/* Hero Section */}
      <div
        className="cloud-deployments-hero-section"
        style={{ backgroundImage: `url(${cloudDeploymentsHero})` }}
      >
        <h1 className="cloud-deployments-animate">{cloudDeploymentsData.hero.title}</h1>
        <p className="cloud-deployments-animate">{cloudDeploymentsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container cloud-deployments-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="cloud-deployments-animate">{cloudDeploymentsData.introduction.heading}</h2>
            {cloudDeploymentsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="cloud-deployments-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 cloud-deployments-image-container">
            <img
              src={cloudDeploymentsHero}
              className="img-fluid cloud-deployments-animate"
              alt="Cloud Deployments"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      </div>

      {/* Deployments Section */}
      <div className="container cloud-deployments-list">
        <div className="row">
          {cloudDeploymentsData.deployments.map((deployment, index) => (
            <div key={index} className="col-md-4 deployment-card cloud-deployments-animate">
              <img
                src={deployment.image}
                className="img-fluid deployment-image"
                alt={deployment.name}
              />
              <h3>{deployment.name}</h3>
              <p>{deployment.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container cloud-deployments-cta">
        <h2 className="cloud-deployments-animate">{cloudDeploymentsData.cta.heading}</h2>
        <p className="cloud-deployments-animate">{cloudDeploymentsData.cta.text}</p>
        <button
          className="btn btn-primary cloud-deployments-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};